<template>
    <div class="footer">
        <img src="@/assets/img/logo.png" class="logo">
        <div class="des">
            成都金沙遗址博物馆版权所有｜<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">蜀ICP备18020442号-1</a>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    data () {
        return {
        }
    },
    methods: {
        /**
        跳转至具体展品页 */
        toExhibitDetail (e) {
            this.$router.push({path: '/exhibitisDetail', query: {id: e}})
        }
    }
}
</script>

<style lang="scss" scoped>
.footer {
    width: 100%;
    height: 178px;
    background-color:rgba($color: #000000, $alpha: .4);
    box-sizing: border-box;
    color: white;
    padding-top: 25px;
    .logo {
        width: 203px;
        height: 44px;
        display: block;
        margin: 20px auto;
    }
    .des {
        font-size: 18px;
        text-align: center;
        color: #d9b766;
    }
    a {
        color: #d9b766;
        text-decoration: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue